exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1fbf0daf] .el-card__body{height:100%}.card__body--nopadding[data-v-1fbf0daf] .el-card__body{padding:10px}.el-dialog .el-card[data-v-1fbf0daf],[data-v-1fbf0daf] .el-card .el-card{border:1px solid var(--lineBorderColor)!important}.to-model-preview[data-v-1fbf0daf]{cursor:pointer}.model_message_wrap[data-v-1fbf0daf]{background-color:#f5f5f5!important;color:#000!important}.model_message_wrap[data-v-1fbf0daf] .el-checkbox__inner{border-color:#000!important}.modelTree-tree[data-v-1fbf0daf]{height:calc(100% - 84px)}", ""]);

// exports
